import { type DeviceTypeEnum } from 'domains/partner-pick-devices/api'

export interface PartnerPickDeviceDatum {
  /** A unique identifier for the device */
  id: string
  /** Type of device */
  deviceType: DeviceTypeEnum
  /** Status for the device */
  active?: boolean
  /** First name for the device */
  firstName: string
  /** Last name for the device */
  lastName: string
  /** Phone number for the device */
  phone: string
  /** Email address for the device */
  email: string
  /** Whether the device belongs to a store manager */
  isPartnerPickStoreManager: boolean
  marqetaCardsMetadata?: MarqetaCardsMetadata
}

export type MarqetaCardsMetadata = {
  physical: number
  digital: number
  inactive: number
  terminated: number
  suspended: number
}

export enum PartnerPickDeviceStatusFilterEnum {
  Active = 'active',
  Inactive = 'inactive',
}

export enum PartnerPickDeviceAccountTypeEnum {
  Shopping = 'shopping',
  Manager = 'manager',
}
export interface PartnerPickDevicesFormData {
  deviceType: DeviceTypeEnum
  accountType: PartnerPickDeviceAccountTypeEnum
  firstName: string
  lastName: string
  phone?: string
  email: string
  password?: string
}
